
import collect from 'collect.js'
// import List from '@/assets/icons/fontawesome/light/list.svg?inline'
import Times from '@/assets/icons/fontawesome/light/times.svg?inline'
import FilterIcon from '@/assets/icons/fontawesome/light/filter.svg?inline'

export default {
  components: {
    // List,
    Times,
    FilterIcon,
  },
  props: {
    aggregator: {
      type: String,
      default: null,
    },
    place: {
      type: Object,
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      default() {
        return {
          sort: 'desc',
          sort_by: 'popular',
        }
      },
    },
    results: {
      type: Array,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        zoom: 14,
        mapId: null,
        scrollwheel: true,
        clickableIcons: false,
        disableDefaultUI: true,
        gestureHandling: 'greedy',
        zoomControl: true,
        scaleControl: true,
        // fullscreenControl: false,
        zoomControlOptions: {
          position: this.dir === 'ltr' ? 8 : 4,
        },
      },
      card: null,
      popup: null,
      cardId: null,
      popupId: null,
      showList: false,
      showFilters: false,
      initialized: false,
      center: {},
    }
  },
  fetch() {
    this.options.mapId =
      this.colorMode === 'dark'
        ? this.$config.googleMapDarkId
        : this.$config.googleMapLightId
  },
  watch: {
    results(newResults, oldResults) {
      if (newResults !== oldResults) {
        this.$nextTick(() => {
          this.clear()
        })
      }
    },
    show(value) {
      if (value) {
        document.querySelector('body').classList.add('overflow-hidden')
      } else {
        document.querySelector('body').classList.remove('overflow-hidden')
      }
    },
    colorMode(value) {
      this.options.mapId =
        value === 'dark'
          ? this.$config.googleMapDarkId
          : this.$config.googleMapLightId
    },
    popupId(value) {
      if (value) {
        this.$nextTick(() => {
          this.popup = collect(this.results).first((item) => {
            return parseInt(item.hotel_id) === parseInt(value)
          })
        })
      }
    },
    cardId(newValue, oldValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.card = collect(this.results).first((item) => {
            return parseInt(item.hotel_id) === parseInt(newValue)
          })
        })

        this.active(document.getElementById(newValue))
      }

      this.unactive(document.getElementById(oldValue))
    },
  },
  mounted() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close()
      }
    })
  },
  methods: {
    updateCenter(center) {
      this.center = {
        lat: center.lat(),
        lng: center.lng(),
      }
    },
    mouseEnter(event) {
      this.$nextTick(() => {
        const x = event.domEvent.clientX + 'px'
        const y = event.domEvent.clientY + 10 + 'px'
        const hoverPopup = document.getElementById('popup')
        if (hoverPopup !== null) {
          if (this.dir === 'rtl') {
            const clientWidth = document.getElementById('map').clientWidth
            hoverPopup.style.right = clientWidth - event.domEvent.clientX + 'px'
          } else {
            hoverPopup.style.left = x
          }
          hoverPopup.style.top = y
        }
      })
    },
    url(data) {
      if (data.hotel.aggregator === 'innstant') {
        return this.localePath({
          name: 'hotels-destination-countrySlug-destinationSlug-hotelSlug',
          params: {
            countrySlug: data.hotel_path.split('/')[0],
            destinationSlug: data.hotel_path.split('/')[1],
            hotelSlug: data.hotel.slug,
          },
          query: this.search || this.searchQuery,
        })
      } else {
        return this.localePath({
          name: 'hotels-place-countrySlug-hotelId',
          params: {
            countrySlug: data.hotel.country.slug,
            hotelId: data.hotel.id,
          },
          query: this.search || this.searchQuery,
        })
      }
    },
    clear() {
      this.cardId = null
      this.popupId = null
    },
    load() {
      this.$emit('load-map', { center: this.center })
    },
    active(element) {
      if (element && element.parentElement) {
        element.parentElement.parentElement.classList.add('z-10')
        element.parentElement.classList.add(
          '!bg-[color:var(--brand-light)]',
          '!dark:bg-[color:var(--brand-dark)]',
          '!text-[color:var(--bg-brand-alt-light)]',
          '!dark:text-[color:var(--bg-brand-alt-dark)]',
        )
      }
    },
    unactive(element) {
      if (element && element.parentElement) {
        element.parentElement.parentElement.classList.remove('z-10')
        element.parentElement.classList.remove(
          '!bg-[color:var(--brand-light)]',
          '!dark:bg-[color:var(--brand-dark)]',
          '!text-[color:var(--bg-brand-alt-light)]',
          '!dark:text-[color:var(--bg-brand-alt-dark)]',
        )
      }
    },
    swipeList(direction) {
      if (screen.width > 639) {
        return
      }
      if (direction === 'right' && this.dir === 'ltr') {
        this.showList = false
      }
      if (direction === 'left' && this.dir === 'rtl') {
        this.showList = false
      }
    },
    swipeFilters(direction) {
      if (screen.width > 639) {
        return
      }
      if (direction === 'left' && this.dir === 'ltr') {
        this.showFilters = false
      }
      if (direction === 'right' && this.dir === 'rtl') {
        this.showFilters = false
      }
    },
    loadMore() {
      if (this.show) {
        this.$emit('load-more')
      }
    },
    close() {
      this.$emit('close')
    },
  },
}
